import { JSX } from 'react'
import { Link } from 'react-router-dom'
import { BasicRoutesEnum } from 'src/routes/routes'
import DefaultButton from 'src/components/buttons/default-button'
import DefaultInput from 'src/components/inputs/default-input'
import { DefaultInputProps } from 'src/components/inputs/default-input/types'
import { cn } from 'src/helpers/cn'
import { FiMail } from 'react-icons/fi'
import { useResetPasswordPage } from './use-reset-password'

const ResetPaswordInput = ({
  className,
  ...props
}: DefaultInputProps): JSX.Element => (
  <DefaultInput
    className={cn('text-[#b0b0b0] text-sm placeholder:text-[#b0b0b0]', className)}
    {...props}
  />
)

const ResetPasswordPage = (): JSX.Element => {
  const { register, handleSubmit, errors, onSubmit, loading, isSended } =
    useResetPasswordPage()

  return (
    <div className="flex flex-col items-center justify-center h-screen w-screen">
      <div className="flex flex-col gap-6">
        <span className="text-[#8d8d8d] text-5xl font-[Orbitron] mx-auto">OPSY</span>

        <div className="p-8 rounded-3xl border border-[#2f2f2f] px-6">
          {isSended ? (
            <div className="flex flex-col items-center w-max gap-4 text-center">
              <FiMail size={48} className="text-white" />
              <span className="text-white font-bold text-2xl text-nowrap">
                Check your email
              </span>
              <span className="text-[#b0b0b0] text-base text-nowrap">
                We&apos;ve sent a password reset link to your email address.
              </span>
              <span className="text-[#b0b0b0] text-base text-nowrap">
                Open the email and follow the instructions to reset your password.
              </span>
              <span className="text-[#b0b0b0] text-sm">
                Didn&apos;t receive an email? Check your spam folder or{' '}
                <button
                  className="text-white font-medium hover:underline"
                  onClick={() => window.location.reload()}
                >
                  try again
                </button>
                .
              </span>
            </div>
          ) : (
            <form
              className="flex flex-col w-104 gap-4"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className="flex flex-col items-center">
                <span className="text-white font-bold text-2xl text-nowrap">
                  Reset Password
                </span>
                <span className="text-[#b0b0b0] text-base text-nowrap">
                  Enter your email to receive a reset link
                </span>
              </div>

              <ResetPaswordInput
                placeholder="Enter email"
                type="email"
                leftIcon={<FiMail size={20} className="mr-3" />}
                error={errors.email?.message}
                {...register('email')}
              />

              <DefaultButton
                type="submit"
                styleType="white"
                className="mt-7"
                label="Send reset link"
                isLoading={loading}
                disabled={loading}
              />
            </form>
          )}
        </div>

        <span className="text-[#b0b0b0] text-sm text-center">
          Don&apos;t have an account?{' '}
          <Link
            to={BasicRoutesEnum.SIGN_UP}
            className="text-white font-medium hover:underline"
          >
            Sign up
          </Link>
        </span>
      </div>
    </div>
  )
}

export default ResetPasswordPage
